import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AUTH_REDUCER } from '../../store/reducers/auth.reducer';
import { distinctUntilChanged, filter, Observable, switchMap, tap } from 'rxjs';
import { AUTH_ACTIONS } from '../../store/actions';
import { ApplicationService } from '../services/application.service';

export const authGuard: CanMatchFn = (): Observable<boolean> => {
  const store = inject(Store);
  const applicationService = inject(ApplicationService);
  const router = inject(Router);

  return store.select(AUTH_REDUCER.selectDiscoveryDocumentLoaded).pipe(
    filter((loaded) => loaded),
    switchMap(() => store.select(AUTH_REDUCER.selectAuthenticated)),
    distinctUntilChanged(),
    tap((isAuthenticated) =>
      isAuthenticated
        ? redirectToLastActiveUrl(applicationService, router)
        : unauthorizedHandler(applicationService, store as Store),
    ),
  );
};

const unauthorizedHandler = (applicationService: ApplicationService, store: Store): void => {
  applicationService.saveActiveUrlToStorage();
  store.dispatch(AUTH_ACTIONS.login());
};

const redirectToLastActiveUrl = (applicationService: ApplicationService, router: Router): void => {
  const urlRedirectAfterLogin: string | null = applicationService.getUrlFromStorage();
  if (urlRedirectAfterLogin) {
    applicationService.removeUrlFromStorage();
    void router.navigateByUrl(urlRedirectAfterLogin, { replaceUrl: true });
  }
};
